import { Spin as BaseSpin, SpinProps } from 'antd';
import { ReactElement } from 'react';
import { Icons } from '../icons';

export function Spin(props: SpinProps): ReactElement {
  BaseSpin.setDefaultIndicator(<Icons name='LoadingIcon' />);
  return <BaseSpin {...props} />;
}
